import { cn } from "@/lib/utils";
import Image from "next/image";

export interface AccreditationCard2Item {
  id: string;
  meta_logo?: string;
  meta_alt_image?: string;
  meta_heading?: string;
  meta_description?: string;
  /** Optional second line rendered bold (e.g. "A+ Grade") */
  meta_highlight?: string;
  meta_heading_color?: string;
  meta_description_color?: string;
}

const AccreditationCard2 = ({
  item,
  className,
}: {
  item: AccreditationCard2Item;
  className?: string;
}) => {
  const headingColor = item.meta_heading_color ?? "#171719";
  const bodyColor = item.meta_description_color ?? "#373737";

  return (
    <article
      className={cn(
        "flex flex-col items-center rounded-xl shadow-[0_4px_24px_rgba(0,0,0,0.06)] py-6 w-full max-w-[288px] bg-[#FFFFFF]",
        className
      )}
    >
      <div className="flex flex-col items-center gap-2 w-full px-4">
        <div
          className={cn(
            "flex items-center justify-center shrink-0 w-[250px] h-[94px]"
          )}
        >
          {item.meta_logo ? (
            <Image
              src={item.meta_logo}
              alt={item.meta_alt_image || "Accreditation logo"}
              width={250}
              height={94}
              className="w-[250px] h-[94px] object-contain"
            />
          ) : null}
        </div>

        <div
          className="h-0.5 w-[217px] max-w-full rounded-full shrink-0"
          style={{ backgroundColor: "#E9E9E9" }}
          aria-hidden
        />

        <div className="flex flex-col gap-2 items-center text-center w-full">
          {item.meta_heading ? (
            <h3
              className={cn(
                "font-semibold text-2xl leading-8 w-full",
                "line-clamp-3"
              )}
              style={{ color: headingColor }}
            >
              {item.meta_heading}
            </h3>
          ) : null}

          {(item.meta_description || item.meta_highlight) && (
            <div
              className="font-normal text-lg leading-normal w-full max-w-[184px] mx-auto"
              style={{ color: bodyColor }}
            >
              {item.meta_description ? (
                <p className="whitespace-pre-wrap mb-0">{item.meta_description}</p>
              ) : null}
              {item.meta_highlight ? (
                <p className="font-bold mb-0 mt-0">{item.meta_highlight}</p>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </article>
  );
};

export default AccreditationCard2;
